import { isArray } from 'util';
import { VibrationPowerMode } from '../vibration-power-mode';

export class VibrationPowerModeBuilder {
  static fromJson(json) {
    return (json)
      ? new VibrationPowerMode(
        json.hash,
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(VibrationPowerModeBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/vibration-power-mode.builder.ts